import styled from 'styled-components';

const Line = styled.div`
  width: 101px;
  height: 1px;
  background-color: #36443A;
`;

export default Line;
